import i18n from '../../../utils/i18n';
import Navigation from '../components/navigation/navigation';
import { TextField } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { bankingInput1 } from '../data/searchFlowText';
import { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ACTIONS from '../../../redux/action';
import { withTranslation } from 'react-i18next';
import NewCheckboxInput2 from '../components/searchInputs/newCheckboxInput2';

const Banks = ({ ...props }) => {
	const companyStore = useSelector((state) => state.company_store);
	const [inputError, setInputError] = useState(false);

	const handleNext = useCallback(
		(inc) => {
			props.handleNext(inc);
		},
		[props]
	);

	const handleBack = useCallback(() => {
		const specialIndustries = [
			'engineer',
			'logistics',
			'manufacturing',
			'education',
			'startup',
			'realestate',
			'lawyer',
			'sport',
			'otherservices',
			'consultancy',
			'other',
		];
		if (specialIndustries.includes(companyStore.industry)) {
			props.handleBack(2);
		} else {
			props.handleBack(1);
		}
	}, [props, companyStore.industry]);

	const dispatch = useDispatch();

	const useStyles = makeStyles({
		root: {
			'& .MuiInputLabel-root': {
				opacity: '0.7',
			},
			'& .MuiOutlinedInput-input': {
				color: '#424559 !important',
				fontFamily: 'Satoshi, sans-serif',
			},
		},
	});

	const classes = useStyles();

	// useEffect(() => {
	//   console.log("REDUX ON MOUNT", companyStore.bankingpref);
	// }, [companyStore.bankingpref]);

	const handleChange = useCallback(
		(event) => {
			const { id } = event.target; // get id from event
			// console.log('BANKING INPUT ID', id);
			dispatch((dispatch, getState) => {
				// Redux Thunk action (redux-thunk middleware)
				const latestState = getState().company_store.bankingpref; // current redux state

				const updatedBankingPref = {
					...latestState,
					[id]: !latestState[id], // reverse checbox value
				};

				dispatch(
					ACTIONS.addCompanyInfo({
						id: 'bankingpref',
						data: updatedBankingPref,
						stateObject: 'company_store',
					})
				);

				// console.log("REDUX UPDATED", updatedBankingPref);
			});
		},
		[dispatch]
	);

	const handleNested = (event, storeId) => {
		dispatch(
			ACTIONS.updateNestedObject({
				stateObject: 'company_store',
				stateObjectID: storeId,
				id: event.target.id,
				data: event.target.value,
			})
		);
	};

	const inputCheck = () => {
		if (
			companyStore.bankingpref.other &&
			companyStore.bankingpref.bankingOtherInput === ''
		) {
			setInputError(true);
			return false;
		} else {
			setInputError(false);
			return true;
		}
	};

	useEffect(() => {
		function handleKeyDown(e) {
			if (e.keyCode === 13) {
				handleNext();
			}
		}
		document.addEventListener('keydown', handleKeyDown);
		return function cleanup() {
			document.removeEventListener('keydown', handleKeyDown);
		};
	}, [props, handleNext]);

	return (
		<div className="stepContainer">
			<div className="SFInput">
				<p className="SFSubTitle">
					<span className="SFSubTitle">
						{i18n.t('searchflow.bankingtitle')}
					</span>{' '}
					<span className="questionTracker">6/8</span>
				</p>
				<NewCheckboxInput2
					dataText={bankingInput1()}
					checkedValues={companyStore.bankingpref}
					handleCheck={handleChange}
				/>
			</div>
			{companyStore.bankingpref.other && (
				<div
					className="SFMarginTop1Rem SFInputWidth100"
					style={{ margin: '16px auto' }}>
					<TextField
						required
						className={`${classes.root}`}
						value={companyStore.bankingpref.bankingOtherInput}
						variant="outlined"
						type={'text'}
						label={i18n.t('industrylabels.other')}
						id="bankingOtherInput"
						name="bankingOtherInput"
						onChange={(event) => {
							handleNested(event, 'bankingpref');
						}}
					/>
				</div>
			)}
			{inputError ? (
				<p
					style={{
						color: 'red',
						fontSize: '12px',
						fontWeight: 'bold',
					}}>
					{i18n.t('company.inputerrormsg')}
				</p>
			) : null}

			<Navigation
				step={8}
				handleBack={() => {
					handleBack();
				}}
				handleNext={() => {
					inputCheck() && handleNext();
				}}
				openHelpForm={() => props.openHelpForm()}
			/>
		</div>
	);
};

export default withTranslation()(Banks);
